/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
 */
export interface ControlcenterMelcoControlCenterModelsDigitizingOrderDetail {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    order_reference_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    design_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    height?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    width?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    measurement_unit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    instructions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    client_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    po_number?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    is_same_day_order?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    is_sew_out?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    thread_supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    promo_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    customer_user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    vendor_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    vendor_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    product_type_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    product_type_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    location_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    location_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    fabric_color_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    fabric_color_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    fabric_type_ids?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    fabric_type_names?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    emb_outline_format_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    emb_outline_format_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    emb_stitch_format_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    emb_stitch_format_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    delivery_option_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    delivery_option_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    delivery_hours?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    order_status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    gxs_order_status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    gxs_status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    error_message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    actual_stitch_count?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    final_stitch_count?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    is_payment_done?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderDetail
     */
    updated_date?: Date | null;
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderDetailFromJSON(json: any): ControlcenterMelcoControlCenterModelsDigitizingOrderDetail {
    return ControlcenterMelcoControlCenterModelsDigitizingOrderDetailFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsDigitizingOrderDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'order_reference_number': !exists(json, 'order_reference_number') ? undefined : json['order_reference_number'],
        'design_name': !exists(json, 'design_name') ? undefined : json['design_name'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'measurement_unit': !exists(json, 'measurement_unit') ? undefined : json['measurement_unit'],
        'instructions': !exists(json, 'instructions') ? undefined : json['instructions'],
        'client_name': !exists(json, 'client_name') ? undefined : json['client_name'],
        'po_number': !exists(json, 'po_number') ? undefined : json['po_number'],
        'is_same_day_order': !exists(json, 'is_same_day_order') ? undefined : json['is_same_day_order'],
        'is_sew_out': !exists(json, 'is_sew_out') ? undefined : json['is_sew_out'],
        'thread_supplier_id': !exists(json, 'thread_supplier_id') ? undefined : json['thread_supplier_id'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'promo_code': !exists(json, 'promo_code') ? undefined : json['promo_code'],
        'customer_user_name': !exists(json, 'customer_user_name') ? undefined : json['customer_user_name'],
        'vendor_id': !exists(json, 'vendor_id') ? undefined : json['vendor_id'],
        'vendor_name': !exists(json, 'vendor_name') ? undefined : json['vendor_name'],
        'product_type_id': !exists(json, 'product_type_id') ? undefined : json['product_type_id'],
        'product_type_name': !exists(json, 'product_type_name') ? undefined : json['product_type_name'],
        'location_id': !exists(json, 'location_id') ? undefined : json['location_id'],
        'location_name': !exists(json, 'location_name') ? undefined : json['location_name'],
        'fabric_color_id': !exists(json, 'fabric_color_id') ? undefined : json['fabric_color_id'],
        'fabric_color_name': !exists(json, 'fabric_color_name') ? undefined : json['fabric_color_name'],
        'fabric_type_ids': !exists(json, 'fabric_type_ids') ? undefined : json['fabric_type_ids'],
        'fabric_type_names': !exists(json, 'fabric_type_names') ? undefined : json['fabric_type_names'],
        'emb_outline_format_id': !exists(json, 'emb_outline_format_id') ? undefined : json['emb_outline_format_id'],
        'emb_outline_format_name': !exists(json, 'emb_outline_format_name') ? undefined : json['emb_outline_format_name'],
        'emb_stitch_format_id': !exists(json, 'emb_stitch_format_id') ? undefined : json['emb_stitch_format_id'],
        'emb_stitch_format_name': !exists(json, 'emb_stitch_format_name') ? undefined : json['emb_stitch_format_name'],
        'delivery_option_id': !exists(json, 'delivery_option_id') ? undefined : json['delivery_option_id'],
        'delivery_option_name': !exists(json, 'delivery_option_name') ? undefined : json['delivery_option_name'],
        'delivery_hours': !exists(json, 'delivery_hours') ? undefined : json['delivery_hours'],
        'order_status': !exists(json, 'order_status') ? undefined : json['order_status'],
        'gxs_order_status': !exists(json, 'gxs_order_status') ? undefined : json['gxs_order_status'],
        'gxs_status': !exists(json, 'gxs_status') ? undefined : json['gxs_status'],
        'error_message': !exists(json, 'error_message') ? undefined : json['error_message'],
        'actual_stitch_count': !exists(json, 'actual_stitch_count') ? undefined : json['actual_stitch_count'],
        'final_stitch_count': !exists(json, 'final_stitch_count') ? undefined : json['final_stitch_count'],
        'is_payment_done': !exists(json, 'is_payment_done') ? undefined : json['is_payment_done'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
    };
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderDetailToJSON(value?: ControlcenterMelcoControlCenterModelsDigitizingOrderDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'order_reference_number': value.order_reference_number,
        'design_name': value.design_name,
        'height': value.height,
        'width': value.width,
        'measurement_unit': value.measurement_unit,
        'instructions': value.instructions,
        'client_name': value.client_name,
        'po_number': value.po_number,
        'is_same_day_order': value.is_same_day_order,
        'is_sew_out': value.is_sew_out,
        'thread_supplier_id': value.thread_supplier_id,
        'supplier_product_id': value.supplier_product_id,
        'promo_code': value.promo_code,
        'customer_user_name': value.customer_user_name,
        'vendor_id': value.vendor_id,
        'vendor_name': value.vendor_name,
        'product_type_id': value.product_type_id,
        'product_type_name': value.product_type_name,
        'location_id': value.location_id,
        'location_name': value.location_name,
        'fabric_color_id': value.fabric_color_id,
        'fabric_color_name': value.fabric_color_name,
        'fabric_type_ids': value.fabric_type_ids,
        'fabric_type_names': value.fabric_type_names,
        'emb_outline_format_id': value.emb_outline_format_id,
        'emb_outline_format_name': value.emb_outline_format_name,
        'emb_stitch_format_id': value.emb_stitch_format_id,
        'emb_stitch_format_name': value.emb_stitch_format_name,
        'delivery_option_id': value.delivery_option_id,
        'delivery_option_name': value.delivery_option_name,
        'delivery_hours': value.delivery_hours,
        'order_status': value.order_status,
        'gxs_order_status': value.gxs_order_status,
        'gxs_status': value.gxs_status,
        'error_message': value.error_message,
        'actual_stitch_count': value.actual_stitch_count,
        'final_stitch_count': value.final_stitch_count,
        'is_payment_done': value.is_payment_done,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
    };
}


